var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Basico / Actulizar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.9619,12 C19.4659,12 19.0389,12.365 18.9789,12.858 C18.5119,16.66 14.9829,19.529 10.9429,18.918 C8.0729,18.483 5.7089,16.229 5.1629,13.378 C4.6909,10.914 5.5199,8.616 7.0829,7.053 C8.3509,5.785 10.1009,5 12.0299,5 C14.0699,5 15.8949,5.889 17.1739,7.287 L14.6309,7.735 C14.0869,7.831 13.7239,8.35 13.8189,8.894 C13.9149,9.437 14.4339,9.801 14.9779,9.705 L19.9719,8.824 C20.5159,8.729 20.8789,8.21 20.7829,7.666 L19.9019,2.672 C19.8069,2.128 19.2879,1.765 18.7439,1.86 C18.1999,1.956 17.8369,2.475 17.9339,3.019 L18.4029,5.685 C16.4429,3.702 13.5919,2.605 10.4869,3.131 C6.8279,3.75 3.8579,6.654 3.1869,10.305 C2.1399,16.008 6.5139,21 12.0309,21 C14.5129,21 16.7629,19.991 18.3929,18.361 C19.7729,16.981 20.7069,15.156 20.9609,13.123 C21.0359,12.527 20.5629,12 19.9619,12",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Basico-/-Actulizar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7f7f7f",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshGrey);
export default __webpack_public_path__ + "static/media/refreshGrey.30243e8a580dd897cc970c7a08a74922.svg";
export { ForwardRef as ReactComponent };